// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"8374e4a7","551":"a3820de4"}[chunkId] + ".chunk.js";
};